export var AssistanceEnum;
(function (AssistanceEnum) {
    AssistanceEnum[AssistanceEnum["WCOB"] = 0] = "WCOB";
    AssistanceEnum[AssistanceEnum["WCMP"] = 1] = "WCMP";
    AssistanceEnum[AssistanceEnum["WCHS"] = 2] = "WCHS";
    AssistanceEnum[AssistanceEnum["WCLB"] = 3] = "WCLB";
    AssistanceEnum[AssistanceEnum["STCR"] = 4] = "STCR";
    AssistanceEnum[AssistanceEnum["WCHC"] = 5] = "WCHC";
    AssistanceEnum[AssistanceEnum["WCBD"] = 6] = "WCBD";
    AssistanceEnum[AssistanceEnum["WCBW"] = 7] = "WCBW";
    AssistanceEnum[AssistanceEnum["DEAF"] = 8] = "DEAF";
    AssistanceEnum[AssistanceEnum["WCHR"] = 9] = "WCHR";
    AssistanceEnum[AssistanceEnum["BLND"] = 10] = "BLND";
})(AssistanceEnum || (AssistanceEnum = {}));
export var AvailabilityEnum;
(function (AvailabilityEnum) {
    AvailabilityEnum[AvailabilityEnum["Available"] = 0] = "Available";
    AvailabilityEnum[AvailabilityEnum["AvailableAfter"] = 1] = "AvailableAfter";
    AvailabilityEnum[AvailabilityEnum["AvailableUntil"] = 2] = "AvailableUntil";
    AvailabilityEnum[AvailabilityEnum["Unavailable"] = 3] = "Unavailable";
})(AvailabilityEnum || (AvailabilityEnum = {}));
export var BaggageInfoEnum;
(function (BaggageInfoEnum) {
    BaggageInfoEnum[BaggageInfoEnum["Allowed"] = 0] = "Allowed";
    BaggageInfoEnum[BaggageInfoEnum["NotAllowed"] = 1] = "NotAllowed";
    BaggageInfoEnum[BaggageInfoEnum["Unknown"] = 2] = "Unknown";
})(BaggageInfoEnum || (BaggageInfoEnum = {}));
export var TransactionStoreIdEnum;
(function (TransactionStoreIdEnum) {
    TransactionStoreIdEnum["PaymentFulfillmentService"] = "PaymentFulfillmentService";
    TransactionStoreIdEnum["PaymentMachine"] = "PaymentMachine";
})(TransactionStoreIdEnum || (TransactionStoreIdEnum = {}));
export var ConnectionResultEnum;
(function (ConnectionResultEnum) {
    ConnectionResultEnum[ConnectionResultEnum["Invalid"] = 0] = "Invalid";
    ConnectionResultEnum[ConnectionResultEnum["Valid"] = 1] = "Valid";
})(ConnectionResultEnum || (ConnectionResultEnum = {}));
export var CustomerValidationDataEnum;
(function (CustomerValidationDataEnum) {
    CustomerValidationDataEnum["FlightCustomerValidationData"] = "FlightCustomerValidationData";
    CustomerValidationDataEnum["FreezeFlightCustomerValidationData"] = "FreezeFlightCustomerValidationData";
})(CustomerValidationDataEnum || (CustomerValidationDataEnum = {}));
export var FlightItinerarySegmentStatusEnum;
(function (FlightItinerarySegmentStatusEnum) {
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["Confirmed"] = 0] = "Confirmed";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["Pending"] = 1] = "Pending";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["Declined"] = 2] = "Declined";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["UnMapped"] = 3] = "UnMapped";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["Canceled"] = 4] = "Canceled";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["ConfirmedPendingNewChange"] = 5] = "ConfirmedPendingNewChange";
    FlightItinerarySegmentStatusEnum[FlightItinerarySegmentStatusEnum["UnMappedPersisted"] = 6] = "UnMappedPersisted";
})(FlightItinerarySegmentStatusEnum || (FlightItinerarySegmentStatusEnum = {}));
export var GetPaymentResultEnum;
(function (GetPaymentResultEnum) {
    GetPaymentResultEnum["Succeeded"] = "Succeeded";
    GetPaymentResultEnum["Pending"] = "Pending";
    GetPaymentResultEnum["Failed"] = "Failed";
})(GetPaymentResultEnum || (GetPaymentResultEnum = {}));
export var InvalidEnum;
(function (InvalidEnum) {
    InvalidEnum["Closed"] = "Closed";
    InvalidEnum["ExcessiveActivity"] = "ExcessiveActivity";
    InvalidEnum["Missing"] = "Missing";
})(InvalidEnum || (InvalidEnum = {}));
export var PassengerTypeEnum;
(function (PassengerTypeEnum) {
    PassengerTypeEnum[PassengerTypeEnum["Adult"] = 0] = "Adult";
    PassengerTypeEnum[PassengerTypeEnum["AgeChild"] = 1] = "AgeChild";
    PassengerTypeEnum[PassengerTypeEnum["LapInfantPrivate"] = 2] = "LapInfantPrivate";
    PassengerTypeEnum[PassengerTypeEnum["SeatedInfantPrivate"] = 3] = "SeatedInfantPrivate";
    PassengerTypeEnum[PassengerTypeEnum["AgelessChild"] = 4] = "AgelessChild";
    PassengerTypeEnum[PassengerTypeEnum["SeatedInfant"] = 5] = "SeatedInfant";
    PassengerTypeEnum[PassengerTypeEnum["AgelessChildPrivate"] = 6] = "AgelessChildPrivate";
    PassengerTypeEnum[PassengerTypeEnum["AdultPrivate"] = 7] = "AdultPrivate";
    PassengerTypeEnum[PassengerTypeEnum["LapInfant"] = 8] = "LapInfant";
})(PassengerTypeEnum || (PassengerTypeEnum = {}));
export var PassengersResponseEnum;
(function (PassengersResponseEnum) {
    PassengersResponseEnum["InvalidPassengers"] = "InvalidPassengers";
    PassengersResponseEnum["PassengersOk"] = "PassengersOk";
})(PassengersResponseEnum || (PassengersResponseEnum = {}));
export var TypeOfPaymentEnum;
(function (TypeOfPaymentEnum) {
    TypeOfPaymentEnum["Rewards"] = "Rewards";
    TypeOfPaymentEnum["Split"] = "Split";
    TypeOfPaymentEnum["UserCard"] = "UserCard";
})(TypeOfPaymentEnum || (TypeOfPaymentEnum = {}));
export var PaymentEnum;
(function (PaymentEnum) {
    PaymentEnum["CreditCard"] = "CreditCard";
})(PaymentEnum || (PaymentEnum = {}));
export var PaymentErrorEnum;
(function (PaymentErrorEnum) {
    PaymentErrorEnum["DuplicateBooking"] = "DuplicateBooking";
    PaymentErrorEnum["PollingTimeout"] = "PollingTimeout";
    PaymentErrorEnum["BookingSessionClosed"] = "BookingSessionClosed";
    PaymentErrorEnum["InvalidCustomer"] = "InvalidCustomer";
    PaymentErrorEnum["InvalidPassengers"] = "InvalidPassengers";
    PaymentErrorEnum["RedemptionFailure"] = "RedemptionFailure";
    PaymentErrorEnum["BookingSessionMissing"] = "BookingSessionMissing";
    PaymentErrorEnum["ErrorCode"] = "ErrorCode";
    PaymentErrorEnum["TicketingUnconfirmed"] = "TicketingUnconfirmed";
    PaymentErrorEnum["TicketingNotStarted"] = "TicketingNotStarted";
    PaymentErrorEnum["NoAvailability"] = "NoAvailability";
    PaymentErrorEnum["InstallmentPaymentFailed"] = "InstallmentPaymentFailed";
    PaymentErrorEnum["CardDeclined"] = "CardDeclined";
    PaymentErrorEnum["TicketingUnknown"] = "TicketingUnknown";
    PaymentErrorEnum["OfferInvalid"] = "OfferInvalid";
    PaymentErrorEnum["BookingSessionRefused"] = "BookingSessionRefused";
    PaymentErrorEnum["CannotResume"] = "CannotResume";
    PaymentErrorEnum["WithTransaction"] = "WithTransaction";
    PaymentErrorEnum["FraudAutoReject"] = "FraudAutoReject";
    PaymentErrorEnum["UpgradeRequired"] = "UpgradeRequired";
    PaymentErrorEnum["UnsupportedPaymentKind"] = "UnsupportedPaymentKind";
    PaymentErrorEnum["QuoteError"] = "QuoteError";
    PaymentErrorEnum["BookError"] = "BookError";
    PaymentErrorEnum["PriceUnavailableUnder25"] = "PriceUnavailableUnder25";
    PaymentErrorEnum["VccGenerationFailure"] = "VccGenerationFailure";
    PaymentErrorEnum["LikelyFraud"] = "LikelyFraud";
    PaymentErrorEnum["NoAdultPassenger"] = "NoAdultPassenger";
    PaymentErrorEnum["IllegalLapInfantRedress"] = "IllegalLapInfantRedress";
    PaymentErrorEnum["IllegalLapInfantKTN"] = "IllegalLapInfantKTN";
    PaymentErrorEnum["LapInfantTooOld"] = "LapInfantTooOld";
    PaymentErrorEnum["TooManyLapInfants"] = "TooManyLapInfants";
    PaymentErrorEnum["NoContactInformation"] = "NoContactInformation";
    PaymentErrorEnum["TooManyPassengers"] = "TooManyPassengers";
    PaymentErrorEnum["MalformedRedressNumber"] = "MalformedRedressNumber";
    PaymentErrorEnum["MalformedKnownTravelerNumber"] = "MalformedKnownTravelerNumber";
    PaymentErrorEnum["LapInfantsUnsupported"] = "LapInfantsUnsupported";
    PaymentErrorEnum["SeatedInfantsUnsupported"] = "SeatedInfantsUnsupported";
    PaymentErrorEnum["ExpiredPassport"] = "ExpiredPassport";
    PaymentErrorEnum["MissingPassport"] = "MissingPassport";
    PaymentErrorEnum["MissingNationality"] = "MissingNationality";
    PaymentErrorEnum["UnsupportedNameCharacters"] = "UnsupportedNameCharacters";
    PaymentErrorEnum["Inactivity"] = "Inactivity";
    PaymentErrorEnum["MissingAirlineLocator"] = "MissingAirlineLocator";
    PaymentErrorEnum["UnknownSabreAppError"] = "UnknownSabreAppError";
    PaymentErrorEnum["MissingPassportNumber"] = "MissingPassportNumber";
    PaymentErrorEnum["InvalidPassportNumber"] = "InvalidPassportNumber";
    PaymentErrorEnum["UserCardNotFound"] = "UserCardNotFound";
})(PaymentErrorEnum || (PaymentErrorEnum = {}));
export var PaymentFinalizeResultEnum;
(function (PaymentFinalizeResultEnum) {
    PaymentFinalizeResultEnum["FlightPaymentFinalizeResult"] = "FlightPaymentFinalizeResult";
    PaymentFinalizeResultEnum["HotelPaymentFinalizeResult"] = "HotelPaymentFinalizeResult";
    PaymentFinalizeResultEnum["GroundPaymentFinalizeResult"] = "GroundPaymentFinalizeResult";
})(PaymentFinalizeResultEnum || (PaymentFinalizeResultEnum = {}));
export var PaymentPriceQuoteDataEnum;
(function (PaymentPriceQuoteDataEnum) {
    PaymentPriceQuoteDataEnum["HotelPriceQuoteData"] = "HotelPriceQuoteData";
    PaymentPriceQuoteDataEnum["CarPriceQuoteData"] = "GroundPriceQuoteData";
})(PaymentPriceQuoteDataEnum || (PaymentPriceQuoteDataEnum = {}));
export var PaymentPriceQuoteRequestEnum;
(function (PaymentPriceQuoteRequestEnum) {
    PaymentPriceQuoteRequestEnum["FlightPriceQuoteRequest"] = "FlightPriceQuoteRequest";
    PaymentPriceQuoteRequestEnum["HotelPriceQuoteRequest"] = "HotelPriceQuoteRequest";
    PaymentPriceQuoteRequestEnum["CarPriceQuoteRequest"] = "GroundPriceQuoteRequest";
})(PaymentPriceQuoteRequestEnum || (PaymentPriceQuoteRequestEnum = {}));
export var PostQuoteAncillariesEnum;
(function (PostQuoteAncillariesEnum) {
    PostQuoteAncillariesEnum["Seats"] = "Seats";
})(PostQuoteAncillariesEnum || (PostQuoteAncillariesEnum = {}));
export var PaymentV2Enum;
(function (PaymentV2Enum) {
    PaymentV2Enum["Rewards"] = "Rewards";
    PaymentV2Enum["UserCard"] = "UserCard";
    PaymentV2Enum["TravelWalletOffer"] = "TravelWalletOffer";
    PaymentV2Enum["TravelWalletCredit"] = "TravelWalletCredit";
    PaymentV2Enum["TravelWalletRestrictedCredit"] = "TravelWalletRestrictedCredit";
    PaymentV2Enum["DisruptionProtectionCredit"] = "DisruptionProtectionCredit";
})(PaymentV2Enum || (PaymentV2Enum = {}));
export var PaymentSplitRequestEnum;
(function (PaymentSplitRequestEnum) {
    PaymentSplitRequestEnum["PaymentCardRequest"] = "PaymentCardRequest";
    PaymentSplitRequestEnum["PaymentCardRewardsRequest"] = "PaymentCardRewardsRequest";
    PaymentSplitRequestEnum["PaymentRewardsRequest"] = "PaymentRewardsRequest";
})(PaymentSplitRequestEnum || (PaymentSplitRequestEnum = {}));
export var PenaltiesInfoEnum;
(function (PenaltiesInfoEnum) {
    PenaltiesInfoEnum["ExternallyManaged"] = "ExternallyManaged";
    PenaltiesInfoEnum["Known"] = "Known";
    PenaltiesInfoEnum["Unknown"] = "Unknown";
})(PenaltiesInfoEnum || (PenaltiesInfoEnum = {}));
export var PenaltyEnum;
(function (PenaltyEnum) {
    PenaltyEnum["NoPenalty"] = "NoPenalty";
    PenaltyEnum["NotPossible"] = "NotPossible";
    PenaltyEnum["Unknown"] = "Unknown";
    PenaltyEnum["WithFee"] = "WithFee";
})(PenaltyEnum || (PenaltyEnum = {}));
export var PostTicketingStatusEnum;
(function (PostTicketingStatusEnum) {
    PostTicketingStatusEnum["Canceled"] = "Canceled";
    PostTicketingStatusEnum["Modified"] = "Modified";
    PostTicketingStatusEnum["Rejected"] = "Rejected";
    PostTicketingStatusEnum["Ticketed"] = "Ticketed";
})(PostTicketingStatusEnum || (PostTicketingStatusEnum = {}));
export var ReasonEnum;
(function (ReasonEnum) {
    ReasonEnum["AlreadyDone"] = "AlreadyDone";
    ReasonEnum["ContactAirline"] = "ContactAirline";
    ReasonEnum["ContactSupport"] = "ContactSupport";
    ReasonEnum["NotAllowed"] = "NotAllowed";
})(ReasonEnum || (ReasonEnum = {}));
export var RegionTypeEnum;
(function (RegionTypeEnum) {
    RegionTypeEnum["Airport"] = "Airport";
    RegionTypeEnum["City"] = "City";
})(RegionTypeEnum || (RegionTypeEnum = {}));
export var HtsAncillaryIdType;
(function (HtsAncillaryIdType) {
    HtsAncillaryIdType["HtsCfarId"] = "HtsCfarId";
    HtsAncillaryIdType["HtsDisruptionId"] = "HtsDisruptionId";
})(HtsAncillaryIdType || (HtsAncillaryIdType = {}));
export var ScheduleUserDenyFlowEnum;
(function (ScheduleUserDenyFlowEnum) {
    ScheduleUserDenyFlowEnum[ScheduleUserDenyFlowEnum["MoveToQueue"] = 0] = "MoveToQueue";
    ScheduleUserDenyFlowEnum[ScheduleUserDenyFlowEnum["ReferToAirline"] = 1] = "ReferToAirline";
})(ScheduleUserDenyFlowEnum || (ScheduleUserDenyFlowEnum = {}));
export var SeatMapResponseEnum;
(function (SeatMapResponseEnum) {
    SeatMapResponseEnum["SeatMapAvailable"] = "SeatMapAvailable";
    SeatMapResponseEnum["SeatMapUnavailable"] = "SeatMapUnavailable";
})(SeatMapResponseEnum || (SeatMapResponseEnum = {}));
export var TicketNumberTypeEnum;
(function (TicketNumberTypeEnum) {
    TicketNumberTypeEnum["InfantNotIssued"] = "InfantNotIssued";
    TicketNumberTypeEnum["TicketNumber"] = "TicketNumber";
})(TicketNumberTypeEnum || (TicketNumberTypeEnum = {}));
export var PricingErrorEnum;
(function (PricingErrorEnum) {
    PricingErrorEnum["PricingDataMissing"] = "PricingDataMissing";
})(PricingErrorEnum || (PricingErrorEnum = {}));
export var ProtectionIdEnum;
(function (ProtectionIdEnum) {
    ProtectionIdEnum["InsuranceId"] = "InsuranceId";
    ProtectionIdEnum["LuggageId"] = "LuggageId";
    ProtectionIdEnum["ProtectionPolicyId"] = "ProtectionPolicyId";
})(ProtectionIdEnum || (ProtectionIdEnum = {}));
export var ProtectionPolicyIdEnum;
(function (ProtectionPolicyIdEnum) {
    ProtectionPolicyIdEnum["CancelOrChangeId"] = "CancelOrChangeId";
    ProtectionPolicyIdEnum["MissedConnectionId"] = "MissedConnectionId";
    ProtectionPolicyIdEnum["ChfarId"] = "ChfarId";
    ProtectionPolicyIdEnum["DelayId"] = "DelayId";
    ProtectionPolicyIdEnum["CfarId"] = "CfarId";
})(ProtectionPolicyIdEnum || (ProtectionPolicyIdEnum = {}));
export var State;
(function (State) {
    State["PendingConfirm"] = "PendingConfirm";
    State["CancelledWithErrors"] = "CancelledWithErrors";
    State["Cancelled"] = "Cancelled";
    State["Failure"] = "Failure";
    State["Confirmed"] = "Confirmed";
    State["PartiallyPaid"] = "PartiallyPaid";
    State["Received"] = "Received";
})(State || (State = {}));
export var ExtraKind;
(function (ExtraKind) {
    ExtraKind["General"] = "General";
    ExtraKind["Other"] = "Other";
    ExtraKind["ExtraDriver"] = "ExtraDriver";
    ExtraKind["Insurance"] = "Insurance";
    ExtraKind["BabyOnBoard"] = "BabyOnBoard";
    ExtraKind["InsuranceExternal"] = "InsuranceExternal";
    ExtraKind["Amenities"] = "Amenities";
})(ExtraKind || (ExtraKind = {}));
export var LinkKind;
(function (LinkKind) {
    LinkKind["PostBookingKeyFactsURI"] = "PostBookingKeyFactsURI";
    LinkKind["PreBookingKeyFactsURI"] = "PreBookingKeyFactsURI";
    LinkKind["PostBookingPolicyWordingURI"] = "PostBookingPolicyWordingURI";
    LinkKind["PreBookingPolicyWordingURI"] = "PreBookingPolicyWordingURI";
    LinkKind["PostBookingCertificateURI"] = "PostBookingCertificateURI";
    LinkKind["PostBookingDIPDanniCertificate"] = "PostBookingDIPDanniCertificate";
    LinkKind["PreBookingDIPDanniCertificate"] = "PreBookingDIPDanniCertificate";
})(LinkKind || (LinkKind = {}));
export var PriceKind;
(function (PriceKind) {
    PriceKind["Extra"] = "Extra";
    PriceKind["ExtraDaily"] = "ExtraDaily";
    PriceKind["ExtraOriginal"] = "ExtraOriginal";
    PriceKind["TotalWithExtra"] = "TotalWithExtra";
})(PriceKind || (PriceKind = {}));
export var RestrictionCancelEnum;
(function (RestrictionCancelEnum) {
    RestrictionCancelEnum["Conditional"] = "Conditional";
    RestrictionCancelEnum["Free"] = "Free";
    RestrictionCancelEnum["Paid"] = "Paid";
})(RestrictionCancelEnum || (RestrictionCancelEnum = {}));
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Km"] = "Km";
    DistanceUnit["Mi"] = "Mi";
})(DistanceUnit || (DistanceUnit = {}));
export var DistKindEnum;
(function (DistKindEnum) {
    DistKindEnum["Limited"] = "Limited";
    DistKindEnum["Unlimited"] = "Unlimited";
})(DistKindEnum || (DistKindEnum = {}));
export var FuelPolicyKind;
(function (FuelPolicyKind) {
    FuelPolicyKind["FullToFull"] = "FullToFull";
    FuelPolicyKind["ReturnSame"] = "ReturnSame";
    FuelPolicyKind["Unknown"] = "Unknown";
    FuelPolicyKind["PrepayRefunds"] = "PrepayRefunds";
    FuelPolicyKind["FreeTank"] = "FreeTank";
    FuelPolicyKind["PrepayNoRefunds"] = "PrepayNoRefunds";
    FuelPolicyKind["MultipleOptionsAtDesk"] = "MultipleOptionsAtDesk";
})(FuelPolicyKind || (FuelPolicyKind = {}));
//# sourceMappingURL=payment-machine.js.map